import yup from "lib/yup-extended";

export const validations = yup.object({
  partners_segment: yup.string().required("Este campo é obrigatório"),
  partners_segment_portfolio: yup.string().required("Este campo é obrigatório"),
  client_employees: yup.string().required("Este campo é obrigatório"),
  partners_reason: yup.string().required("Este campo é obrigatório"),
  products_to_sell__c: yup.array().of(yup.string())
});
